import { defineStore } from 'pinia'
import { GET } from '~/composables/fetchingTools'
interface GalleryState {
  designs: any[]
  hasLoaded: boolean
  currentPage: number
  totalPages: number
  isLoading: boolean
}

export const useGalleryStore = defineStore('gallery', {
  state: (): GalleryState => ({
    designs: [],
    hasLoaded: false,
    currentPage: 1,
    totalPages: 1,
    isLoading: false
  }),

  actions: {
    async loadDesigns() {
      if (this.hasLoaded && this.currentPage === 1) return
      
      this.isLoading = true
      const response = await GET(`/api/galery?page=${this.currentPage}`)
      
      if (response) {
        if (this.currentPage === 1) {
          this.designs = response.designs
        } else {
          this.designs = [...this.designs, ...response.designs]
        }
        
        this.totalPages = response.pagination.totalPages
        this.hasLoaded = true
      }
      
      this.isLoading = false
    },

    async loadMore() {
      if (this.currentPage >= this.totalPages || this.isLoading) return
      
      this.currentPage++
      await this.loadDesigns()
    }
  }
}) 